import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Get } from "../../../queries/utils/api";
import GenieProcessing from "../../../components/core/genie-processing/GenieProcessing";
import { Box, Alert } from "@mui/material";
import GeniePage from "../../../components/special/genie-page/GeniePage";

function CheckoutReturn() {
  const [searchParams] = useSearchParams();
  const { org_id } = useParams();
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const sessionId = searchParams.get("session_id");
        if (!sessionId) {
          throw new Error("No session ID provided");
        }

        const accessToken = await getAccessTokenSilently();
        const response = await Get<{ success: boolean; error?: string }>(
          `/api/stripe/organization/${org_id}/verify-payment/${sessionId}`,
          accessToken
        );

        if (response.success) {
          // Payment successful, redirect to orders page
          navigate(`/storefront/${org_id}/orders`);
        } else {
          setError(response.error || "Payment verification failed");
        }
      } catch (err) {
        setError((err as Error).message || "An unexpected error occurred");
      }
    };

    verifyPayment();
  }, [org_id, searchParams, getAccessTokenSilently, navigate]);

  if (error) {
    return (
      <GeniePage>
        <Box mt={4}>
          <Alert severity="error">{error}</Alert>
        </Box>
      </GeniePage>
    );
  }

  return (
    <GenieProcessing
      phrases={[
        "Finalizing your payment...",
        "Almost there...",
        "Processing your order...",
      ]}
    />
  );
}

export default CheckoutReturn;
